import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';
import LoadingIndicator from "flarum/components/LoadingIndicator";

import UserManageUserListItem from "./UserManageUserListItem";
import UserManageInviteCodeListItem from "./UserManageInviteCodeListItem";
import InviteCodeAddRegisterModal from "./modal/InviteCodeAddRegisterModal";
import InviteCodeAddExtensionModal from "./modal/InviteCodeAddExtensionModal";
import selectButton from "../common/util/selectButton";

export default class UserManageSidebarComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.mapModule = this.attrs.mapModule;
    this.viewType = this.attrs.viewType;
    this.searchKeyword = (this.attrs.searchKeyword).trim();
    this.loading = true;
    this.moreResults = false;
    this.u2diInviteCodeList = [];

    this.loading = true;
    this.inviteCodeTypeFilter = Stream(0);
    this.loadInviteCodeResult();
    
    const _this = this;

    $(window).off("u2diInviteCodeAdd").on("u2diInviteCodeAdd",function(e){
      _this.filterItem(e);
    })
  }

  onupdate(vnode) {
    const searchKeyword = (this.attrs.searchKeyword).trim();
    
    if(this.searchKeyword!==searchKeyword){
      this.searchKeyword = searchKeyword;
      this.filterItem();
    }
  }

  view() {
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const mapModule = this.mapModule;
    const _this = this;
    let loading;
    let targetList = this.u2diInviteCodeList;
    let switchButtonStyle = "";

    if (this.loading) {
      loading = LoadingIndicator.component({ size: "large" });
      switchButtonStyle = "pointer-events:none";
    }

    return (
      <div>
        {this.viewType==="normal" && (
          <div>
            <div className="u2diInfoItemContainer" style="display: flex; padding-bottom: 1px;">
              <div style={switchButtonStyle+";width:84px;text-align: center;"} group="userInviteCodeTypes" className="u2diSelectionButton u2diSelectionButtonSelected2" onclick={(e) => selectButton(e,"u2diSelectionButtonSelected2",function(){
                _this.switchInviteCodeTypes(0);
              })}>
                {app.translator.trans('ziven-u2di.forum.button-invite-code-register')}
              </div>
              <div style={switchButtonStyle+";margin-left: 3px;width:84px;text-align: center;"} group="userInviteCodeTypes" className="u2diSelectionButton" onclick={(e) => selectButton(e,"u2diSelectionButtonSelected2",function(){
                _this.switchInviteCodeTypes(1);
              })}>
                {app.translator.trans('ziven-u2di.forum.button-invite-code-extension')}
              </div>
              <div style="margin-left: 8px;">
                {this.inviteCodeTypeFilter()===0 && (
                  <Button style="width: 120px;" className={'Button U2DiButton--green'} disabled={this.loading} onclick={(e) => app.modal.show(InviteCodeAddRegisterModal)}>
                    {app.translator.trans('ziven-u2di.forum.button-add-invite-code-register')}
                  </Button>
                )}
                {this.inviteCodeTypeFilter()===1 && (
                  <Button style="width: 120px;" className={'Button U2DiButton--green'} disabled={this.loading} onclick={(e) => app.modal.show(InviteCodeAddExtensionModal)}>
                    {app.translator.trans('ziven-u2di.forum.button-add-invite-code-extension')}
                  </Button>
                )}
              </div>
            </div>
            <div>
              {targetList.map((targetData) => {
                return (
                  <div id={"u2diInviteCode"+targetData.id()} style="padding-top: 5px;">
                    {UserManageInviteCodeListItem.component({ targetData,mapModule })}
                  </div>
                );
              })}
            </div>
            {!this.loading && targetList.length===0 && (
              <div>
                <div style="font-size:1.4em;color: var(--muted-more-color);text-align: center;height: 300px;line-height: 100px;">{app.translator.trans("ziven-u2di.lib.list-empty")}</div>
              </div>
            )}

            {!loading && this.hasMoreResults() && (
              <div className="u2di-loadMore" style="text-align:center;padding:20px">
                <Button className={'Button Button--primary '} disabled={this.loading} loading={this.loading} onclick={() => this.loadMore()}>
                  {app.translator.trans('ziven-u2di.lib.load-more')}
                </Button>
              </div>
            )}

            {loading && <div className="u2di-loadMore">{loading}</div>}
          </div>
        )}

        {this.viewType==="mobile" && (
          <div className="u2diMapSideBarMobileContentArea">
            <div className="u2diMapSideBarMobileContentContainer">
              {targetList.map((targetData) => {
                return (
                  <div style="padding-top: 5px;">
                    {UserManageInviteCodeListItem.component({ targetData,mapModule })}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }

  switchInviteCodeTypes(codeType){
    if(codeType!==this.inviteCodeTypeFilter()){
      this.inviteCodeTypeFilter(codeType);
      this.filterItem();
    }
  }

  filterItem(){
    this.u2diInviteCodeList = [];
    this.loading = true;
    m.redraw();

    this.loadInviteCodeResult();
  }

  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.u2diInviteCodeList, results);
    this.loading = false;
    m.redraw();

    return results;
  }

  loadMore() {
    this.loading = true;
    this.loadInviteCodeResult(this.u2diInviteCodeList.length);
  }

  hasMoreResults() {
    return this.moreResults;
  }

  loadInviteCodeResult(offset = 0){
    const filters = {
      codeType:this.inviteCodeTypeFilter(),
      keyword:this.searchKeyword
    };

    app.store
      .find("u2diInviteCodeList", {
      filter:filters,
      page: {
        offset,
      },
    })
    .catch(() => {})
    .then(this.parseResults.bind(this));
  }

}